(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("vue-blu", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["vue-blu"] = factory(require("vue"));
	else
		root["vue-blu"] = factory(root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_83__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition